/**
 * @description 用户管理 userManage
 * @author 系统生成
 * @date 2018/9/20
 */

import Logic from '../logic-base'

const userManageBiz = new Logic()

userManageBiz.findUser = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.userManage.findUser,
    data: data
  })
}

userManageBiz.addUser = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.userManage.addUser,
    data: data
  })
}

userManageBiz.amendUser = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.userManage.amendUser,
    data: data
  })
}

userManageBiz.distributeUser = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.userManage.distributeUser,
    data: data
  })
}

userManageBiz.deleteUser = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.userManage.deleteUser,
    data: data
  })
}

userManageBiz.getSelfInfo = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.userManage.getSelfInfo,
    data: data
  })
}

userManageBiz.updateSelfInfo = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.userManage.updateSelfInfo,
    data: data
  })
}

export default userManageBiz
